module.exports = __webpack_public_path__ + "img/noble1.7a0ae390.png";